import { FC, useMemo } from 'react';

import { beautifyEnum } from 'src/utils/utility';
import TransportMediumIcon from '../card/TransportMediumIcon';
import { IUploadSectionProvidersProps } from './types';
import { UploadSection } from './Section';

export const UploadSectionProvider: FC<IUploadSectionProvidersProps> = ({ data, children, defaultExpanded = true }) => {
  const invoiceDetail = useMemo(() => data?.[0]?.invoiceDetail, [data]);

  const uniqueModalities = useMemo(() => {
    const allModalities = data?.flatMap((item) => item.invoiceDetail?.modalities || []) || [];
    return [...new Set(allModalities)];
  }, [data]);

  const modalityTitle = useMemo(() => {
    if (uniqueModalities.length === 0) return '';

    const formatModality = (modality: string) => {
      switch (modality) {
        case 'CT':
          return 'CONTROL TOWER';
        case 'COURIER':
          return 'COURIER';
        default:
          return modality;
      }
    };

    return uniqueModalities.map(formatModality).join(' & ');
  }, [uniqueModalities]);

  return (
    <UploadSection
      defaultExpanded={defaultExpanded}
      header={
        <div className='flex items-center'>
          <div className='flex-1'>
            <div className='flex-1 flex items-center gap-12'>
              <div className='flex items-center gap-4'>
                {uniqueModalities.map((modality) => (
                  <TransportMediumIcon key={modality} medium={modality} iconColor='#9F9F9F' />
                ))}
              </div>
              <div className='flex items-center gap-8'>
                <strong className='text-14 xl:text-16 font-bold'>{beautifyEnum(invoiceDetail?.serviceProviderCode)?.toUpperCase()}</strong>
                {modalityTitle && (
                  <>
                    <div className='w-4 h-4 bg-blue_grey-30 rounded-full' />
                    <strong className='text-12 xl:text-14 font-medium text-grey-40'>{modalityTitle}</strong>
                  </>
                )}
                <div className='w-4 h-4 bg-blue_grey-30 rounded-full' />
                <div className='text-12 xl:text-14 font-bold'>{data?.length} items</div>
              </div>
            </div>
          </div>
        </div>
      }
    >
      {children}
    </UploadSection>
  );
};
